export const iconConfigs = [
    {
        conditionKey: 'showOddsBoostBanner',
        iconClass: 'babyslip__odds-boost-icon',
    },
];
